import { render, staticRenderFns } from "./InvestigatorDetailInput.vue?vue&type=template&id=77ea5bf9&scoped=true&"
import script from "./InvestigatorDetailInput.vue?vue&type=script&lang=js&"
export * from "./InvestigatorDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./InvestigatorDetailInput.vue?vue&type=style&index=0&id=77ea5bf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea5bf9",
  null
  
)

export default component.exports